/* ── Section map ──────────────────────────────────────────
   Single source of truth for the journey: order, ids, rail
   labels, and how many viewport-widths each section spans in
   horizontal mode. Every consumer (rail, navbar, camera
   zones, scroll driver) derives from this list. */

export const SECTIONS = [
  { id: "top", label: "Intro", screens: 1 },
  { id: "about", label: "About", screens: 2 },
  { id: "skills", label: "Skills", screens: 2 },
  { id: "experience", label: "Experience", screens: 4 },
  { id: "projects", label: "Projects", screens: 7 },
  { id: "contact", label: "Contact", screens: 2 },
  { id: "outro", label: "Contact", screens: 1 },
];

export const TOTAL_SCREENS = SECTIONS.reduce((n, s) => n + s.screens, 0);

/* The track translates (TOTAL_SCREENS - 1) screen-widths in
   total, so all progress fractions use that denominator:
   progress p ⇒ the viewport's LEFT edge sits at screen p*(T-1). */
const DENOM = TOTAL_SCREENS - 1;

/* Camera-space fraction at which each section starts/ends —
   used to place 3D zones along the world. `end` of the final
   section may exceed 1; zones there sit just past the last
   camera position, inside its forward view. */
export const SECTION_RANGES = (() => {
  let acc = 0;
  return SECTIONS.map((s) => {
    const start = acc / DENOM;
    acc += s.screens;
    return { ...s, start, end: acc / DENOM };
  });
})();

/* Active section = the one under the viewport's center. */
export function sectionIndexAt(progress) {
  const center = progress * DENOM + 0.5;
  let acc = 0;
  for (let i = 0; i < SECTIONS.length; i++) {
    acc += SECTIONS[i].screens;
    if (center < acc) return i;
  }
  return SECTIONS.length - 1;
}

/* Scroll fraction that puts a section's first panel flush
   with the viewport's left edge. */
export function sectionStart(id) {
  let acc = 0;
  for (const s of SECTIONS) {
    if (s.id === id) return Math.min(acc / DENOM, 1);
    acc += s.screens;
  }
  return 0;
}
